<template>
  <label class="toggle">
    <input
      :class="classes"
      type="checkbox"
      :checked="value ? 'checked' : ''"
      :name="name"
      :disabled="disabled"
      v-model="checked"
      :tabindex="tab ? 0 : -1"
    />
    <img :src="value ? iconOn : iconOff" />
  </label>
</template>

<script>
export default {
  name: 'IconToggle',
  props: {
    disabled: Boolean,
    classes: String,
    value: Boolean,
    name: String,
    iconOff: String,
    iconOn: String,
    tab: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      checked: undefined,
    };
  },
  beforeMount() {
    this.checked = this.value;
  },
  mounted() {
    this.$emit('input', this.checked);
  },
  watch: {
    checked(val) {
      if (this.value !== this.checked) {
        this.$emit('input', val);
      }
    },
    value(val) {
      this.checked = val;
    },
  },
};
</script>

<style scoped>
label.toggle input[type='checkbox'] {
  opacity: 0;
}
label.toggle img {
  width: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/iconToggle/iconToggle.vue